import { SizableText } from 'tamagui';
import { useAppTranslation } from '@hooks/useAppTranslation';

interface FieldErrorProps {
  message?: string;
}

export const FieldError = ({ message }: FieldErrorProps): React.ReactNode => {
  const { t } = useAppTranslation();

  if (!message) {
    return null;
  }

  return (
    <SizableText size="$2" color="$error" fontFamily="$body">
      {t(message)}
    </SizableText>
  );
};
